import { VerifyMedicationStatus } from "@/types/__generated__/union-types"

const MEDICATION_VERIFICATION_STATUSES: VerifyMedicationStatus[] = ["NOT_ENQUIRED", "NONE"]

const NOT_ENQUIRED_STATUS = "NOT_ENQUIRED"

export { MEDICATION_VERIFICATION_STATUSES, NOT_ENQUIRED_STATUS }
